import { render, staticRenderFns } from "./StudentFilledAdminForm.vue?vue&type=template&id=3e010210&"
import script from "./StudentFilledAdminForm.vue?vue&type=script&lang=ts&"
export * from "./StudentFilledAdminForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentFilledAdminForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports